<template>
    <div class="common-fold-container" ref="common-fold-container">
        <div v-if="isSupport" class="collapse-panel">
            <div class="panel-body">
                <div :style="{ height: showHeight }">
                    <flow-container :children="tpl.children"></flow-container>
                </div>
            </div>
            <div class="collapse-btn" ref="collapseBtn" :style="{ backgroundColor: bottomColor }">
                <p
                    v-if="showText"
                    class="collapse-text"
                    v-html="btnText"
                    @click="toggleCollapse"
                    :style="{ color: textColor }"
                ></p>
                <div class="iconct" @click="toggleCollapse">
                    <Icon class="collapse-icon" :isActive="!isCollapsed" :iconColor="iconColor"></Icon>
                </div>
            </div>
        </div>
        <div v-else class="no-suppert-mask">
            未部署<a href="https://fego.futuoa.com/admin/cn#/plugin/version?id=20">复杂插件功能包</a>,
            请联系管理人员部署
        </div>
    </div>
</template>

<script>
const {
    plugins: { ComplexComp }
} = require('@futuweb/fego-render');
import Icon from '../render/icon.vue';
import './index.less';

export default {
    components: {
        Icon,
        FlowContainer: ComplexComp.Container.Flow
    },
    props: {
        tpl: Object,
        collapseType: Number,
        iconColor: String,
        textColor: String,
        expandText: String,
        collapseText: String,
        scaleHeight: Number,
        defaultCollapsed: Number,
        bottomColor: String
    },
    data() {
        return {
            isSupport: !!ComplexComp,
            isCollapsed: !!this.defaultCollapsed
        };
    },
    computed: {
        showText() {
            return this.collapseType && this.btnText;
        },
        btnText() {
            if (this.isCollapsed) {
                return this.expandText;
            } else {
                return this.collapseText;
            }
        },
        showHeight() {
            return this.isCollapsed ? `${this.scaleHeight / 100}rem` : 'auto';
        }
    },
    methods: {
        toggleCollapse() {
            this.isCollapsed = !this.isCollapsed;
        }
    }
};
</script>
<style lang="less" scoped></style>
